// Link pessoal do prestador: tamoaki.co.ao/pedir?p=<codigo_indicacao>.
// O pedido feito por este link vai primeiro a esse prestador; se ele não puder
// ou não responder, segue para os outros prestadores verificados da zona
// (ver migração 20261006_pedido_link_pessoal no repositório admin).

/** Código do link pessoal (?p=TAM-XXXXXX), ou null se não vier um válido. */
export function codigoPrestadorDoUrl(search: string): string | null {
  const p = new URLSearchParams(search).get('p')?.trim().toUpperCase() ?? '';
  return /^TAM-[A-Z0-9]{4,12}$/.test(p) ? p : null;
}

/** Primeiro nome, para o texto do formulário ("Vai primeiro para o João"). */
export function primeiroNome(nome: string | null | undefined): string {
  return (nome ?? '').trim().split(/\s+/)[0] || 'este prestador';
}
